import inMemoryJwt from '../../auth/inMemoryJwt';
import { urlServer } from '../../config/GlobalConstant';
import {
    SET_PRODUCT_TO_TRANSFER_CART, ADD_TO_TRANSFER_CART,
    SET_QUANTITY_TO_TRANSFER_CART, ADD_TO_PENDING_ORDERS,
    GET_PENDING_ORDER_BY_ID, GET_CONSOLIDATE_PRODUCTS,
    GET_PENDING_ORDERS, CLEAR_PENDING_ORDERS, CLEAR_TRANSFER_CART,
    ADD_SPECIFICATION, ADD_SPECIFICATION_DEVOLUTION, CLEAR_SPECIFICATION_DEVOLUTION,
    CLEAR_SPECIFICATION, IS_LOADING_BESTSELLER_PRODUCTS,
    GET_BESTSELLER_PRODUCTS
} from '../actions/types'
import Swal from 'sweetalert2';
const toast = Swal.mixin({

    position: 'top-end',
    showConfirmButton: false,
    timer: 2000
})
export const setProductToTranfer = (product) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
        type: SET_PRODUCT_TO_TRANSFER_CART,
        payload: product
    });

}
export const setQuantityToTranfer = (quantity) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
        type: SET_QUANTITY_TO_TRANSFER_CART,
        payload: quantity
    });
}
export const addToTranferCart = (item) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
        type: ADD_TO_TRANSFER_CART,
        payload: {
            product: item.consolidateProduct,
            quantity: parseInt(item.quantity)
        }
    });

}
export const createPendingOrders = (items, destiny, history) => async dispatch => {
    const products = items.map(item => {
        return {
            productId: item.product._id,
            quantity: parseInt(item.quantity)
        }
    })
    await fetch(`${urlServer}productorders/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            transmitterEntityId: destiny,
            //    transmitterEntityId: "61df5ddb4e81c4ab4191aa28",
            products: products
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
                    type: CLEAR_TRANSFER_CART
                });
                // history.push(`/Admin/Inventory/PendingOrders`)
                history.push({
                    pathname: `/Admin/Inventory/PendingOrders`,
                    state: {
                        type: "catering",
                    }
                })
            }

        })


}
export const clearPendingOrders = () => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
        type: CLEAR_PENDING_ORDERS
    });
}
export const getPendingOrders = (status, orderType) => async dispatch => {
    await fetch(`${urlServer}productorders/get-concept-status`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            orderType,
            status: status,
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
                    type: GET_PENDING_ORDERS,
                    payload: respJson.data
                });
            } else {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
                    type: GET_PENDING_ORDERS,
                    payload: []
                });
            }
        })
}
export const clearSubOrdes = () => dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
        type: GET_PENDING_ORDER_BY_ID,
        payload: []
    });

}

export const getSubOrdes = (id) => async dispatch => {

    await fetch(`${urlServer}productsuborders/get-by-order`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            orderId: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
                    type: GET_PENDING_ORDER_BY_ID,
                    payload: respJson.data
                });

            }
        })
}
export const getSubOrdesByCode = (code) => async dispatch => {

    await fetch(`${urlServer}productsuborders/get-by-order-code`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            code: code
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {

                if (respJson.data[0]?.orderId.status ===3) {
                    dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
                        type: GET_PENDING_ORDER_BY_ID,
                        payload: respJson.data
                    });
                } else {
                    toast.fire({
                        icon: "error",
                        text: "La orden debe estar despachada"
                    })
                }
            }
        })
}


export const addSpecificationDevolution = (specification) => async dispatch => {
    dispatch({
        type: ADD_SPECIFICATION_DEVOLUTION,
        payload: specification
    });


}
export const clearSpecificationDevolution = (specification) => async dispatch => {
    dispatch({
        type: CLEAR_SPECIFICATION_DEVOLUTION,
    });
}


export const addSpecification = (specification) => async dispatch => {
    dispatch({
        type: ADD_SPECIFICATION,
        payload: specification
    });


}
export const clearSpecification = (specification) => async dispatch => {
    dispatch({
        type: CLEAR_SPECIFICATION,
    });
}

export const getBestSellerProducts = (page, limit = 5) => async dispatch => {
    dispatch({ type: IS_LOADING_BESTSELLER_PRODUCTS });

    await fetch(`${urlServer}products/get-report-by-type`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            reportType: "topSold",
            limit,
            skip: page,
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {

                dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
                    type: GET_BESTSELLER_PRODUCTS,
                    payload: respJson.data
                });
            }
            else {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
                    type: GET_BESTSELLER_PRODUCTS,
                    payload: []
                });
            }
        }).catch(error => {

        })
}
export const getConsolidateProducts = (page, textString, categoryId, subcategoryId, limit = 50) => async dispatch => {
    await fetch(`${urlServer}maininventories/get-consolidate-products`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            limit,
            skip: page,
            textString,
            categoryId,
            subcategoryId
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {

                dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
                    type: GET_CONSOLIDATE_PRODUCTS,
                    payload: respJson.data
                });
            }
            else {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
                    type: GET_CONSOLIDATE_PRODUCTS,
                    payload: []
                });
            }
        }).catch(error => {

        })
}

export const mmanageOrder = ({ orderId, specifications, status, paymentStatus, reasonForRejection }, history) => async dispatch => {
    await fetch(`${urlServer}productorders/manage`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ orderId, specifications, status, paymentStatus, reasonForRejection })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                switch (status) {

                    case 1:
                        toast.fire({
                            text: "Orden rechazada"
                        })
                        break;
                    case 2:
                        toast.fire({
                            text: "Orden aprobada"
                        })
                        break;
                    case 3:
                        toast.fire({
                            text: "Orden despachada"
                        })
                        break;
                    case 4:
                        toast.fire({
                            text: "Orden entregada"
                        })
                        break;

                    default:
                        break;
                }
                history.push('/Admin/Inventory/PendingOrders')
            } else {

            }


        })
}



export const getDevolutions = (receivingWineryId, solved, history) => async dispatch => {
    await fetch(`${urlServer}productdevolutions/get-by-status`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ receivingWineryId, solved })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({
                    type: "GET_DEVOLUTIONS",
                    payload: respJson.data
                })
            } else {
                dispatch({
                    type: "GET_DEVOLUTIONS",
                    payload: []
                })
            }

        })
}



export const getDevolutionById = (productDevolutionId, history) => async dispatch => {
    await fetch(`${urlServer}productdevolutiondetails/get-by-devolution`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ productDevolutionId })
    })
        .then(response => response.json())
        .then(respJson => {

            if (respJson.success) {
                dispatch({
                    type: "GET_DEVOLUTIONS_DETAILL",
                    payload: respJson.data
                })
            } else {
                dispatch({
                    type: "GET_DEVOLUTIONS_DETAILL",
                    payload: []
                })
            }


        })
}

export const manageDevolutions = (devolutionId, specifications, history) => async dispatch => {
    await fetch(`${urlServer}productdevolutions/manage`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ devolutionId, specifications })
    })
        .then(response => response.json())
        .then(respJson => {



        })
}





